// 2026-10-07：详情顶部分类回到原列表历史条目，连续查看关联商品时仍保留来源页码。
import type { Router, RouteLocationNormalized } from 'vue-router'

const originKey = 'landiyunCatalogOrigin'
const listPaths = new Set(['bokes', 'cloths', 'retails', 'fabrics', 'accessories', 'decorations'].map(name => '/main/' + name))
const detailPaths = new Set(['/main/bokesdetail', '/main/clothdetail', '/main/retailDetails', '/main/retailCloth', '/main/fabricdetails', '/main/decorationDetails'].map(path => path.toLowerCase()))
interface Origin { scope: string; path: string; position: number }
const isDetail = (path: string): boolean => detailPaths.has(path.toLowerCase())
const validOrigin = (value: unknown, scope: string): value is Origin => {
  if (typeof value !== 'object' || !value) return false
  const origin = value as Origin
  return origin.scope === scope && listPaths.has(origin.path) && Number.isInteger(origin.position) && origin.position >= 0
}

export function installCatalogReturnNavigation(router: Router, scope: () => string): void {
  // 每次导航独立保存来源；被取消/重定向的导航不得污染后来完成的页面。
  const pending = new WeakMap<RouteLocationNormalized, Origin>()
  router.beforeEach((to, from) => {
    if (!isDetail(to.path)) return
    const state = window.history.state
    if (!state || state.current !== from.fullPath || !Number.isInteger(state.position)) return
    const saved = state.landiyunCatalogReturn
    if (listPaths.has(from.path) && saved?.path === from.path && saved.scope === scope()) {
      pending.set(to, {scope: saved.scope, path: from.path, position: state.position})
    } else if (isDetail(from.path) && validOrigin(state[originKey], scope())) {
      pending.set(to, state[originKey])
    }
  })
  router.afterEach((to, _from, failure) => {
    const origin = pending.get(to)
    pending.delete(to)
    if (failure || !origin || !validOrigin(origin, scope())) return
    const state = window.history.state
    if (state?.current !== to.fullPath || !Number.isInteger(state.position) || state.position <= origin.position) return
    try {
      window.history.replaceState({...state, [originKey]: origin}, '')
    } catch (_error) {
      // 浏览器禁止历史状态写入时保留原导航，不阻断商品浏览。
    }
  })
}

export function returnToCatalog(router: Router, targetPath: string, scope: string): boolean {
  const state = window.history.state
  const origin = state?.[originKey]
  if (!isDetail(router.currentRoute.value.path) || state?.current !== router.currentRoute.value.fullPath ||
      !validOrigin(origin, scope) || origin.path !== targetPath || !Number.isInteger(state.position) || state.position <= origin.position) return false
  // 只返回这条详情链的原列表；其他分类、首页新浏览、直接打开详情和跨账号/店铺保持原入口。
  router.go(origin.position - state.position)
  return true
}
